<template>
    <div id="gallery-photo-page">
        <!-- similar to albumPhoto -->
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>
        <div v-if="albumPhoto !== null && albumPhoto.hasOwnProperty('photo')">
            <app-header :info="albumPhoto.photo" :title="capitalize(title)" :imagePath="imagePath" isType="photo" isClass="is-fullheight1"></app-header>

            <!-- <div class="custom-description" v-if="albumPhoto.photo.album">
                <h2 class="subtitle is-size-1">{{ albumPhoto.photo.album.name }}</h2>
                <div v-html="albumPhoto.photo.album.description"></div>
            </div>

            <div class="custom-description" v-if="albumPhoto.photo.location.description">
                <h2 class="subtitle is-size-1">{{ albumPhoto.photo.location.name }}</h2>
                <div v-html="albumPhoto.photo.location.description"></div>
            </div> -->

            <div class="columns nav-container mtb-80 rel">
                <div class="breadcrumbs-parent" style="left:20px; display: flex;">
                    <ul>
                        <li><router-link to="/galerija">Galerija</router-link></li>
                        <li v-text="capitalize(title)"></li>
                    </ul>
                </div>
                <!-- prev -->
                <div class="column">
                    <p class="wide has-text-centered"> {{ albumPhoto.prev.location.name | capitalize }}</p>
                    <p class="intro has-text-centered">{{ albumPhoto.prev.date }}</p>
                    <a class="prev" v-if="albumPhoto.prev" :href="albumPhoto.prev.slug">
                        <img :src="getPhoto(albumPhoto.prev)" :alt="albumPhoto.prev.name" />
                    </a>
                </div>

                <div class="column special-blockquote complex-line column">
                    <span class="related weather"></span>
                    <blockquote class="item">
                        <span>{{ albumPhoto.quote.quote }}</span>
                        <cite>{{ albumPhoto.quote.author }}</cite>
                    </blockquote>
                </div>

                <!-- next -->
                <div class="column has-text-right">
                    <p class="wide has-text-centered">{{ albumPhoto.next.location.name | capitalize }}</p>
                    <p class="intro has-text-centered">{{ albumPhoto.prev.date }}</p>
                    <a class="next" v-if="albumPhoto.next" :href="albumPhoto.next.slug">
                        <img :src="getPhoto(albumPhoto.next)" :alt="albumPhoto.next.name" />
                    </a>
                </div>
            </div>
            <h3 class="links"><a :href="slug">Vse slike</a></h3>

            <app-google-map :mapName="capitalize(this.title)" :glat="albumPhoto.photo.location.lat" :glng="albumPhoto.photo.location.lng"></app-google-map>
        </div>
    </div>
</template>

<script>
import { ApiHome, GalleryAlbumLink } from '../../.env';
import { mapGetters, mapActions } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';
import GoogleMaps from '../../components/elements/gmaps/GoogleMaps.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';

export default {
    props: ['photo', 'photoDetails'],
    mixins: [StringsMixin],

    data() {
        // console.log('photo: ', this.photo, this.photoDetails, this);
        return {
            endpoint: ApiHome+ 'photo/' + this.photo,
            photoSize: '1960',
            // photoSize: 'original',
            photoSmall: '300'
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-back': BackButton,
        'app-google-map': GoogleMaps,
        'app-sb': Silentbox,
    },

    computed: {
        ...mapGetters([
            'albumPhoto',
            'loading',
            'error',
            'title'
        ]),
        imagePath() {
            // console.log('photo: ', this.albumPhoto.photo.location);
            return this.albumPhoto.photo.imagePath;
        },

        slug() {
            return GalleryAlbumLink + this.albumPhoto.photo.album.slug;
        }
    },

    methods: {
        fetchPhoto() {
            // console.log('FETCH photo (album-photo): ', this.photo, this.endpoint, this.album, this.$router);
            let album = '';
            if(typeof(this.album) !== 'undefined') {
                album = this.album;
            }
            let data = {
                endpoint: this.endpoint,
                type: 'photo',
                photo: this.photo,
                // album: !!this.album
            };
            // console.log('PHOTO data: ', data);
            this.$store.dispatch('fetchPhoto', data);
        },

        getPhoto(item) {
            return item.imagePath;
        }
    },

    created() {
        this.fetchPhoto();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/gallery/GalleryPhoto.vue